<template lang="html">

    <section class="registro">

        <encabezado :data="'generarNuevoConvenio'"></encabezado>


        <form class="form row-start ais container">


            <div class="contenedor-boton -relleno-data row-start">
                <a @click="requestUltimoConvenio" class="btn -solid-primary">Rellenar datos</a>
                <popup-info :texto="'ultimoconvenio'" :side="'right'"></popup-info>
            </div>


            <p>
                <strong>
                    Por favor, cumplimente los siguientes datos para generar el Convenio de Cooperación Educativa entre
                    su empresa y UC3M.
                </strong>
            </p>

            <h2 class="epigrafe">Datos del firmante</h2>


            <div class="contenedor-input type-text one-slot">
                <label for="">{{$t('oferta.nombre')}} del firmante*</label>
                <input type="text" v-validate="'required|min:3|max:150'" name="nombre" v-model="data.datosFirmante.nombre">
                <span class='error' v-if="clicked">{{ errors.first('nombre') }}</span>
            </div>

            <div class="contenedor-input type-text one-slot">
                <label for="">{{$t('oferta.apellidos')}} del firmante*</label>
                <input type="text" v-validate="'required|min:3|max:150'" name="apellidos" v-model="data.datosFirmante.apellidos">
                <span class='error' v-if="clicked">{{ errors.first('apellidos') }}</span>
            </div>


            <div class="contenedor-input type-text one-slot">
                <label for="">{{$t('oferta.email')}}</label>
                <input type="text" v-validate="'email'" name="email" v-model="data.datosFirmante.email">
                <span class='error' v-if="clicked">{{ errors.first('email') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot">
                <label for="">{{$t('oferta.cargo')}}*</label>
                <input type="text" v-validate="'required|min:3|max:150'" name="cargo" v-model="data.datosFirmante.cargo">
                <span class='error' v-if="clicked">{{ errors.first('cargo') }}</span>
            </div>
            <div class="contenedor-input type-text three-slot" v-if="brand.tratamiendoDatosConvenio">
                <div class="container-label-info">
                    <label class="label-info" for="">Información sobre tratamiento de datos personales por parte de la entidad* </label>
                    <popup-info :texto="'tratamiento_datos'" :side="'left'"></popup-info>
                </div>
                <textarea :placeholder="placeholderTratamientoDatos" maxlength="50000" v-validate="'required|min:3|max:5000'" name="informacionTratamientoDeDatos" v-model="informacionTratamientoDeDatosTexto" multiline rows="30" />
                <span class='error' v-if="clicked">{{ errors.first('informacionTratamientoDeDatos') }}</span>
            </div>

            <div class="contenedor-input row-start type-text three-slot">
                <label for="">Modalidad de firma*</label>
                <div class="row-start radio-wrapper">
                    <div class="radio-container">
                        <input type="radio" :value="false" id="digital" v-model="data.tramitacionManual" name="tramitacionManual" v-validate="'required'">
                        <label for="digital">Digital (electrónica con certificado)</label>
                    </div>
                    <div class="radio-container">
                        <input type="radio" :value="true" id="manual" v-model="data.tramitacionManual" name="tramitacionManual" v-validate="'required'">
                        <label for="manual">En papel</label>
                    </div>
                </div>
                <span class='error' v-if="clicked">{{ errors.first('tramitacionManual')}}</span>
            </div>





            <div class="contenedor-input type-text three-slot -wo-margin">
                <label for="">Selecciona un contacto gestión*</label>
                <select name="idContactoEmpresaGestion" v-model="data.idContactoEmpresaGestion" v-validate="'required'">
                    <option v-if="Object.values(contactos).length != 0" value="">-Selecciona el contacto-</option>
                    <option v-else value="">-Pulse añadir contacto para añadir-</option>
                    <option v-if="!!contactos" v-for="(el, key) in contactos" :value="key">{{el}}</option>
                </select>
                <span class='error' v-if="clicked">{{ errors.first('idContactoEmpresaGestion') }}</span>
            </div>

            <div class="contenedor-input type-text three-slot -wo-margin">
                <label for="">Selecciona un contacto de facturación*</label>
                <select name="idContactoEmpresaFacturacion" v-model="data.idContactoEmpresaFacturacion" v-validate="'required'">
                    <option v-if="Object.values(contactosFacturacion).length != 0" value="">-Selecciona el contacto-</option>
                    <option v-else value="">-Pulse añadir contacto para añadir-</option>
                    <option v-if="!!contactosFacturacion" v-for="(el, key) in contactosFacturacion" :value="key">{{el}}</option>
                </select>
                <span class='error' v-if="clicked">{{ errors.first('idContactoEmpresaFacturacion') }}</span>
            </div>


            <add-contacto v-if="newuser.show" @added="addedContact" @close="newuser.show = false"></add-contacto>

            <div class="contenedor-boton row-start">

                <a class="row-start add-link" @click="newuser.show = true" v-if="newuser.show == false">
                    <add-icon></add-icon>Añadir nuevo contacto
                </a>

            </div>



            <h4 class="epigrafe">Información económica</h4>


            <p><strong>Gastos de Gestión</strong></p>
            <p>La Fundación facturará a la empresa o institución colaboradora 50 euros +I.V.A. / mes, en concepto de Gestión de Prácticas. Esta cifra podrá revisarse de acuerdo con el IPC. Dicha cantidad es independiente de la que la empresa pudiera aportar al estudiante en concepto de Ayuda al Estudio.</p>
            <p class="mb50">La Fundación emitirá una factura a la finalización del periodo de prácticas que se computará en función de los meses y fracción correspondiente de días transcurridos. El citado abono por servicios, es una obligación que asume la Entidad Colaboradora desde el momento de la incorporación del alumno a las prácticas.</p>


            <div class="three-slot with-toggle row-start">
                <div class="contenedor-toogle">
                    <toggle :show_result="false" :show="true" :label="'Requiere número de pedido'" :dataServer="data.requierePedido" v-model="data.requierePedido"></toggle>
                </div>
            </div>

            <div class="three-slot with-toggle row-start" v-if="data.requierePedido">
                <div class="contenedor-toogle">
                    <toggle :show_result="false" :show="true" :label="'¿Tiene número de pedido anual?'" :dataServer="data.pedidoAnual" v-model="data.pedidoAnual"></toggle>
                </div>
            </div>

            <div class="contenedor-input type-text three-slot" v-if="data.pedidoAnual">
                <label for="">Número de pedido anual</label>
                <input type="text" v-validate="'required|max:250'" name="numeroPedido" v-model="data.numeroPedido">
                <span class='error' v-if="clicked">{{ errors.first('numeroPedido') }}</span>
            </div>



            <div class="contenedor-input type-text three-slot -forma-pago">
                <label for="">Forma de pago</label>

                <div class="opcion-pago">
                    <div class="radio-container">
                        <input type="radio" :value="true" id="domiciliacion" v-model="data.pagoDomiciliado" name="pagoDomiciliado" v-validate="'required'">
                        <label for="domiciliacion">Domiciliación</label>
                    </div>

                    <div class="detalle-pago" v-if="data.pagoDomiciliado === true">
                        <div class="contenedor-input type-text middle-slot -wo-margin">
                            <label for="">IBAN*</label>
                            <input type="text"  id="ibanN" v-model="data.ibanDomiciliacion" name="ibanN" v-validate="{ required: true, regex: /([a-zA-Z]{2})\s*\t*(\d{2})\s*\t*(\d{4})\s*\t*(\d{4})\s*\t*(\d{2})\s*\t*(\d{10})$/ }" placeholder ="ES XX XXXX XXXX XX XXXXXXXXXX">
                            <span class='error' v-if="clicked">{{ errors.first('ibanN') }}</span>
                        </div>
                    </div>
                </div>

                <div class="opcion-pago">
                    <div class="radio-container">
                        <input type="radio" :value="false" id="otrasFormasPago" v-model="data.pagoDomiciliado" name="pagoDomiciliado" v-validate="'required'">
                        <label for="otrasFormasPago">Otras formas de pago</label>
                    </div>

                    <div class="detalle-pago" v-if="data.pagoDomiciliado === false">
                        <div class="contenedor-input type-text -wo-margin">
                            <label class="sublabel" for="">Selecciona el método</label>
                            <div class="radio-container">
                                <input type="radio" value="transferencia" id="transferencia" v-model="formaPagoAlternativa" name="formaPagoAlternativa" v-validate="'required'">
                                <label for="transferencia">Transferencia</label>
                            </div>
                            <span class='error' v-if="clicked">{{ errors.first('formaPagoAlternativa')}}</span>
                        </div>
                    </div>
                </div>

                <span class='error' v-if="clicked">{{ errors.first('pagoDomiciliado')}}</span>
            </div>




            <div class="contenedor-boton">
                <a @click="validate" :loading="loadingbtn" class="btn -solid-primary">Descargar convenio</a>
            </div>

            <div class="legal-info">
                <h2>INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS CONFORME EL NUEVO REGLAMENTO EUROPEO</h2>
                <p><strong>RESPONSABLE:</strong> FUNDACIÓN UNIVERSIDAD CARLOS III 91 624 9902 dspo@fund.uc3m.es</p>
                <p><strong>FINALIDAD PRINCIPAL:</strong> Activación del Convenio de Cooperación Educativa con la
                    Universidad Carlos III
                    de Madrid, gestionado por la Fundación Universidad Carlos III.</p>
                <p><strong>LEGITIMACIÓN:</strong> Consentimiento del interesado, ejecución de un contrato o interés
                    legítimo.</p>
                <p><strong>DESTINATARIOS:</strong> Se cederán datos a la Universidad Carlos III de Madrid DERECHOS:
                    Acceder, rectificar
                    y suprimir los datos, portabilidad de los datos, limitación u oposición a su tratamiento,
                    transparencia y derecho a no ser objeto de decisiones automatizadas.</p>
                <p><strong>INFORMACIÓN ADICIONAL:</strong> Puede consultar la información adicional y detallada sobre
                    nuestra Política de
                    Privacidad en <a href="https://www.fundacion.uc3m.es/politica-de-privacidad" target="_blank">https://www.fundacion.uc3m.es/politica-de-privacidad</a> DATA PROTECTION OFFICER
                    (DPO):
                    GRUPO ADAPTALIA LEGAL-FORMATIVO S.L. <a href="tel:915533408">915533408</a> <a href="mailto:legal@grupoadaptalia.es">legal@grupoadaptalia.es</a></p>

            </div>

            <confirm-popup :texto="'Los datos consignados en este formulario quedarán grabados en su perfil de empresa. Por favor revíselos y asegúrese de que son correctos.'" :titulo="'¿Desea continuar?'" :textoaceptar="'Si, generar convenio'" :textorechazar="'No, revisar formulario'" :loading="loading" v-if="showpopup" @accept="sendData" @cancel="showpopup = false">
            </confirm-popup>



        </form>

        <!-- <loading v-else></loading> -->




    </section>

</template>

<script lang="js">

    import encabezado from '@/components/parts/encabezado';

    import arrowLink from '@/components/parts/icons/arrow-link'

    import { mapGetters, mapActions } from 'vuex';

    import toggle from '@/components/parts/form/toggle'

    import addIcon from '@/components/parts/icons/add'

    import Datepicker from 'vuejs-datepicker';

    import { ca, es } from 'vuejs-datepicker/dist/locale';

    import popupInfo from '@/components/parts/popup-info';

    import loading from '@/components/parts/loading';

    import axios from 'axios'


    import addContacto from '@/components/views/documentacion/addContacto'
    import addCuentaFacturacion from '@/components/views/documentacion/addCuentaFacturacion'


    import router from '@/router';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { Validator } from 'vee-validate';

    import confirmPopUp from '@/components/parts/confirm-popup';


    Validator.extend('checkdni', {
        validate: value => {
            var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
            var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
            var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
            var str = value.toString().toUpperCase();

            if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

            var nie = str
                .replace(/^[X]/, '0')
                .replace(/^[Y]/, '1')
                .replace(/^[Z]/, '2');

            var letter = str.substr(-1);
            var charIndex = parseInt(nie.substr(0, 8)) % 23;

            if (validChars.charAt(charIndex) === letter) return true;

            return false;
        },
        getMessage: field => 'El campo DNI está mal formado',
    });


    export default {
        name: 'solicitud-cambio-practica',
        mounted() {
            if (this.brand.tratamiendoDatosConvenio) {
                this.requestInfoTratamientoDatos()
            }
            if (this.brand.canCrearConvenios) {
                this.requestContactos();
                this.requestCuentaFacturacion();
                this.requestContactosFacturacion();

            } else {
                router.push("/");
            }

        },
        data() {
            return {
                clicked: false,
                placeholderTratamientoDatos: 'Responsable del tratamiento de datos: --incluir texto--\nCorreo electrónico de contacto: --incluir texto--',
                loading: false,
                loadingbtn: false,
                es: es,
                ca: ca,
                data: {
                    "idContactoEmpresaGestion": '',
                    "idContactoEmpresaFacturacion": "",
                    "tramitacionManual": null,
                    "idCuentaFacturacion": '',
                    "datosFirmante": {
                        "nombre": "",
                        "apellidos": "",
                        "dni": "",
                        "cargo": "",
                        "email": "",
                        "telefono": ""
                    },
                    "fechaCaducidad": null,
                    "requierePedido": false,
                    "informacionTratamientoDeDatos": null,
                    "pedidoAnual": false,
                    "numeroPedido": "",
                    "pagoDomiciliado": null,
                    "ibanDomiciliacion": "",
                    "fakefechaCaducidad": "",
                    "sincaducidad": true
                },
                newuser: {
                    "show": false
                },
                newaccount: {
                    "show": false
                },
                contactos: '',
                contactosFacturacion: '',
                cuentas: '',
                camposiban: [4, 4, 4, 2, 10],
                iban: ['', '', '', '', ''],
                showpopup: false,
                formaPagoAlternativa: ''

            }
        },
        watch: {
            'data.pagoDomiciliado'(value) {
                if (value !== false) {
                    this.formaPagoAlternativa = '';
                }
            }
        },
        computed: {
            ...mapGetters({
                dominios: 'getDominios',
                dominiosOrder: 'getDominiosOrder',
                brand: 'getBrand',
                tiposContacto: 'getTipoContactoEmpresa',
                paises: 'getPaises',
                provincias: 'getProvincias',
            }),

            // El servicio devuelve el texto con etiquetas <br>; en el textarea se
            // muestran como saltos de linea reales y se reconvierten al guardar.
            informacionTratamientoDeDatosTexto: {
                get() {
                    if (!this.data.informacionTratamientoDeDatos) return this.data.informacionTratamientoDeDatos;
                    return this.data.informacionTratamientoDeDatos.replace(/<br\s*\/?>/gi, '\n');
                },
                set(value) {
                    this.data.informacionTratamientoDeDatos = value ? value.replace(/\r\n|\r|\n/g, '<br/>') : value;
                },
            },
        },
        methods: {
            ...mapActions(['addConvenioEmpresa']),
            requestContactos() {
                axios.get(`/api/empresa/dameContactosConveniosEmpresa`).then(r => {
                    if (r.data.status == 0) {
                        this.contactos = r.data.datos;
                        if (Object.values(this.contactos).length == 1) {
                            this.data.idContactoEmpresaGestion = Object.keys(this.contactos)[0];
                        }
                    }
                }).catch(error => {
                    commit('setError', 500);
                    dispatch('sendErrorServer', error.response);
                });
            },
            requestInfoTratamientoDatos() {
                axios.get(`/api/empresa/damedatosempresa `).then(r => {
                    if (r.data.status == 0) {
                        this.data.informacionTratamientoDeDatos = r.data.datos.informacionTratamientoDeDatos;
                        // console.log(r.data.datos)
                    }
                }).catch(error => {
                    commit('setError', 500);
                    dispatch('sendErrorServer', error.response);
                });
            },
            requestContactosFacturacion() {
                axios.get(`/api/empresa/dameContactosFacturacionEmpresa`).then(r => {
                    if (r.data.status == 0) {
                        this.contactosFacturacion = r.data.datos;
                    }
                }).catch(error => {
                    commit('setError', 500);
                    dispatch('sendErrorServer', error.response);
                });
            },
            requestCuentaFacturacion() {
                axios.get(`/api/empresa/dameCuentasFacturacion`).then(r => {
                    if (r.data.status == 0) {
                        this.cuentas = r.data.datos;
                        if (!!this.cuentas && this.cuentas.length == 1) {
                            this.data.idCuentaFacturacion = this.cuentas[0].idCuenta;
                        }
                    }
                }).catch(error => {
                    commit('setError', 500);
                    dispatch('sendErrorServer', error.response);
                });
            },
            requestUltimoConvenio() {
                axios.get(`/api/empresa/dameDetalleUltimoConvenioEmpresa`).then(r => {
                    if (r.data.status == 0) {
                        this.data = r.data.datos;
                        this.formaPagoAlternativa = this.data.pagoDomiciliado === false ? 'transferencia' : '';
                    }
                }).catch(error => {
                    commit('setError', 500);
                    dispatch('sendErrorServer', error.response);
                });
                if (this.brand.tratamiendoDatosConvenio) {
                    this.requestInfoTratamientoDatos()
                }

            },
            addedContact() {
                this.newuser.show = false;
                this.requestContactos();
                this.requestContactosFacturacion()
            },
            addedAccount() {
                this.newaccount.show = false;
                this.requestCuentaFacturacion();
            },
            setDoc(value) {
                this.data.adjunto.ficheroB64 = value.ficheroB64ParaAltas;
                this.data.adjunto.extension_adjunto = value.extension_adjunto;
            },
            validate() {
                this.clicked = true;
                this.$validator.validateAll()
                    .then(itsOk => {
                        if (itsOk) {
                            this.clicked = false;
                            this.showpopup = true;
                        } else {
                            $('html,body').animate({ scrollTop: $("*[aria-invalid=true").offset().top - 150 }, 400);
                        }

                    });
            },
            sendData() {
                this.loading = true;
                this.addConvenioEmpresa(this.data).then(r => {
                    this.loading = false;
                    if (r) {
                        this.showpopup = false;
                    }
                });
            },
            
        },
        components: {
            'encabezado': encabezado,
            'arrow-link': arrowLink,
            'toggle': toggle,
            'add-icon': addIcon,
            Datepicker,
            'popup-info': popupInfo,
            'loading': loading,
            'add-contacto': addContacto,
            'add-cuenta-facturacion': addCuentaFacturacion,
            'confirm-popup': confirmPopUp,
        }
    }



</script>

<style scoped lang="scss">
    @import '@/assets/css/colors.scss';

    form {
        padding-top: 50px;
    }

    .epigrafe {
        margin-bottom: 20px;
    }

    .contenedor-boton {
        margin-top: 0px;
        padding-left: 30px;
        width: 100%;
        margin-bottom: 30px;

        &.-relleno-data {
            width: auto;
            display: inline-block;
            position: relative;
            padding-right: 30px;

            .popup-info {
                right: 0;
            }
        }
    }

    .form .with-toggle {
        width: 100%;
        margin-bottom: 30px;


        .contenedor-toogle {
            position: relative;
            right: auto;
            top: auto;
        }

        &.fecha {
            width: 33.33333333%;
            margin-bottom: 0;
            padding-bottom: 0;

            .contenedor-toogle {
                position: absolute;
                right: 0px;
                top: 0px;
            }
        }
    }

    .-forma-pago {
        margin-bottom: 5px;

        > label {
            margin-bottom: 5px;
        }

        .opcion-pago {
            width: 100%;
            display: inline-block;
        }

        .radio-container {
            margin-right: 0;
        }

        // Bloque de detalle que cuelga de cada opción, alineado con el texto del radio
        .detalle-pago {
            position: relative;
            margin-left: 7px;
            padding-left: 18px;
            padding-bottom: 5px;
            border-left: 1px solid $soft-black;
            text-align: left; // los contenedor-input son inline-block y body centra por defecto

            .sublabel {
                font-weight: 400;
                font-size: 14px;
                line-height: 30px;
                color: $medium-black;
            }

            // Cada detalle usa su propio contenedor-input, que ya reserva el hueco de su error
            .contenedor-input {
                margin-bottom: 0;
            }
        }
    }

    .-iban label {
        width: 100%;
    }

    .-iban input {
        width: auto;
        letter-spacing: 1px;
    }

    .-iban span {
        margin: 0 5px;

        &:last-of-type {
            display: none;
        }
    }

    .contenedor-iban {
        flex-wrap: nowrap;
    }

    .-iban input[campos=n-2] {
        width: calc(12px * 2);
    }

    .-iban input[campos=n-4] {
        width: calc(12px * 4);
    }

    .-iban input[campos=n-10] {
        width: calc(12px * 10);
    }

    .legal-info {
        max-width: 800px;
        padding-left: 30px;
        margin-top: 20px;

        h2 {
            text-align: left;
            font-size: 15px;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            font-size: 13px;
            margin-bottom: 0px;
        }
    }


    @media screen and (max-width: 900px) {
        .contenedor-boton {
            padding-left: 0px;
            margin-top: 30px;
        }

        .add-link {
            margin-left: 0;
        }


        .legal-info {
            padding-left: 0;
        }

        .form .with-toggle.fecha {
            width: 100%;
        }

    }

    @media screen and (max-width: 340px) {
        .form .with-toggle.fecha strong {
            font-size: 14px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/documentacion/generar-nuevo-convenio.vue